/** Return a safe public WalletConnect project ID, or null when not configured. */
export function parseWalletConnectProjectId(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const projectId = value.trim();
  if (!/^[0-9a-fA-F]{32}$/.test(projectId) || /^0{32}$/.test(projectId)) return null;
  return projectId.toLowerCase();
}
